var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('breadcrumb', {
    attrs: {
      "data": _vm.breadcrumbData
    }
  }), _c('add-or-edit', {
    attrs: {
      "code": _vm.code
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };